var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'base-admintag-container',
    { disabled: _vm.disabled } ].concat( _vm.additionalStyles ),attrs:{"title":_vm.helpText},on:{"click":_vm.onClick}},[_c('div',{staticClass:"label"},[_c('span',[_vm._v(_vm._s(_vm.textContent))])])])}
var staticRenderFns = []

export { render, staticRenderFns }